<template>
	<p class="bold-text is-size-4 mb-5-mobile mb-6-tablet">Please select a plan</p>
	<div class="columns is-multiline is-mobile px-2 is-centered">
		<div v-for="(plan, idx) in filteredPlans" :key="plan.id" class="column is-half-mobile is-half-tablet is-one-quarter-desktop px-2-mobile px-3-tablet card-wrapper">
			<plan-card 
				:plan="plan" 
				:bgImage="`${leadsConstants.PLANS_BG_IMAGES[idx % leadsConstants.PLANS_BG_IMAGES.length]}`">
			</plan-card>
		</div>
	</div>
	<button class="button is-primary is-fullwidth mx-auto my-6 bold-text" :disabled="!isValidForPayment" @click="nextStep">Select</button>
</template>
<script lang="ts">
import { defineComponent, PropType } from "vue";
import { Steps } from '@/models/LeadsState';
import { STATE_MODULES } from "@/store/state-modules";
import { LeadsGetters } from "@/store/modules/leads/getters";
import { mapGetters } from "vuex";
import leadsConstants from "@/constants/leads";
import { LeadsMutations } from "@/store/modules/leads/mutations";
import PlanCard from "../PlanCard.vue";

export default defineComponent({
	data () {
		return {
			leadsConstants
		}
	},
	props: {
		plansToShow: {
			type: Array as PropType<number[]>,
			default: () => leadsConstants.LEADS_PLANS_TO_SHOW.DEFAULT
		}
	},
	computed: {
		...mapGetters(STATE_MODULES.LEADS, { 
			plans: LeadsGetters.LEADS_PLANS,
			isValidForPayment: LeadsGetters.IS_VALID_FOR_PAYMENT
		}),
		filteredPlans (): any {
			return this.plansToShow.map((id) => this.plans[id]).filter((plan) => plan);
		}
	},
	methods: { 
		nextStep () { 
			this.$store.commit(`${STATE_MODULES.LEADS}/${LeadsMutations.SET_STEP}`, Steps.PAYMENT)
		}
	},
	components: {
		PlanCard
	}
})
</script>

<style scoped>
    .card-wrapper, .button {
		max-width: 300px;
		min-width: 280px;
	}

	@media (max-width: 1300px) { 
		.card-wrapper {
			min-width: 230px!important;
		}
	}

	@media (max-width: 768px) {
		.card-wrapper { 
			min-width: unset;
			max-width: 250px;
		}
	}

	@media (max-width: 400px) {
		.card-wrapper {
			width: 250px!important;
		}
	}
</style>
